import { stiffSpring } from 'shared/kanimate';
import cloneDeep from 'lodash/cloneDeep';

import { appBorderColor, appBoxShadowColor, appBoxShadowColorSecondary, appBackgroundColor } from 'globals/colors';

import { chatAppHeightPercentage } from 'globals/styles';

export const staticStyles = {
  wrapper: {
    position: 'fixed',
    bottom: '25px',
    right: '25px',
    width: '375px',
    minHeight: '400px',
    maxHeight: '600px',
    height: 'calc(100% - 110px)',
    pointerEvents: 'all',
    '@media (max-width: 600px)': {
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      height: '100%',
      width: '100%',
      minHeight: 'initial',
      minWidth: 'initial',
      maxHeight: '100%',
      maxWidth: '100%',
    },
  },
  border: {
    display: 'flex',
    flexDirection: 'column',
    height: `${chatAppHeightPercentage}%`,
    width: '100%',
    position: 'relative',
    borderRadius: '10px',
    backgroundColor: appBackgroundColor,
    border: `solid 1px ${appBorderColor}`,
    boxShadow: `0px 2px 10px 0px ${appBoxShadowColor}, 0 2px 32px 0 ${appBoxShadowColorSecondary}`,
    transform: 'translate(150px, 1000px)',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      borderRadius: '0',
      boxShadow: 'none',
      border: 'none',
    },
  },
};

export const start = {
  x: 150,
  y: 200,
  scale: 0.1,
};

export const end = () => {
  return {
    x: stiffSpring(0),
    y: stiffSpring(0),
    scale: stiffSpring(1),
  };
};

export const tween = values => {
  return {
    border: {
      transform: `translate(${values.x}px, ${values.y}px) scale(${values.scale})`,
    },
  };
};

export const startRTL = {
  x: -150,
  y: 200,
  scale: 0.1,
};

const rtlOverrides = cloneDeep(staticStyles);
rtlOverrides.wrapper.right = 'auto';
rtlOverrides.wrapper.left = '25px';

export const staticStylesRTL = rtlOverrides;
